import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const Endpoint = '/api/sectores-actividadesProductivas';

// ✅ Instancia de Axios con baseURL y timeout
const api = axios.create({
    baseURL: config.baseUrl,
    timeout: 5000, // ⏳ Evita que las peticiones se queden colgadas
});

// 🛡️ Interceptor para agregar el token automáticamente
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 📦 Servicio para obtener sectores y actividades productivas
export const obtenerSectoresxActividadesProductivas = async () => {
    try {
        const response = await api.get(Endpoint);

        if (response.data.success && response.data.data) {
            return {
                success: true,
                sectores: response.data.data.sectores,
                actividadesProductivas: response.data.data.actividadesProductivas
            };
        }

        return {
            success: false,
            message: response.data.message || 'No se encontraron sectores ni actividades productivas.'
        };

    } catch (error) {
        console.error('❌ Error al obtener sectores y actividades productivas:', error);

        if (error.response) {
            // 🟠 Error del servidor
            return {
                success: false,
                message: error.response.data?.message || 'Error del servidor al obtener los datos.'
            };
        } else if (error.request) {
            // 🔴 Error de red
            return {
                success: false,
                message: 'No se pudo conectar con el servidor. Verifica tu conexión a internet.'
            };
        } else {
            // ⚪ Error inesperado
            return {
                success: false,
                message: 'Ocurrió un error inesperado. Inténtalo nuevamente.'
            };
        }
    }
};

export default obtenerSectoresxActividadesProductivas;
